import { TabsManager } from "./TabsManager";

export default TabsManager